import { notificationManager } from '../Stores/NotificationManager'
import { restClient } from '@/Core'

export const LoadUnreadCountTask = async () => {
    try {
        // forceRefresh: unread count must reflect the latest read/unread state,
        // not RestClient's ~30s cached GET (otherwise the badge flips back).
        const response = await restClient.get(
            '/services/user/notifications',
            {
                searchParams: {
                    page: 1,
                    limit: 1,
                    filters: JSON.stringify({
                        and: [{ field: 'isReaded', op: '=', value: false }],
                    }),
                },
            },
            { forceRefresh: true }
        )

        const total = response?.meta?.total ?? 0
        notificationManager.setUnreadCount(total)
    } catch {
        // Silently ignore — badge just won't update
    }
}
